module.exports = __webpack_public_path__ + "media/assets/images/logo_auren-64912d3578c24518aab81085e53e477b.svg";